<template>
  <div>
    <div class="main-card mt-2">
      <div class="card-header">
        <ul class="nav nav-tabs card-header-tabs nav-fill">
          <li class="nav-item hoverPointer" @click="tabIndex = 0">
            <a class="nav-link" :class="isActive(0)">General Information</a>
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div deck v-if="tabIndex == 0">
          <GeneralInfoTab :value="value" />
        </div>
      </div>

      <div v-if="hasAssociatedAccount(value)" class="card-footer">
        <span :id="'impersonate-gen' + value.apparatusId">
          <button
            type="button"
            class="btn btn-primary mt-2"
            @click="ImpersonateEmail()"
            :disabled="!hasAssociatedAccount(value)"
            data-toggle="tooltip"
            :title="hasAssociatedAccount(value) ? '' : 'No Owner Account'"
            data-test-hook="go-to-dashboard-button-search-result"
          >
            Impersonate User
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import * as Constants from '@/constants'
import GeneralInfoTab from '@/components/Admin/GeneralInfoTab'
import { mapState } from 'vuex'

export default {
  components: {
    GeneralInfoTab
  },
  props: ['value'],
  data() {
    return {
      tabIndex: 0,
      currentStatus: null,
      currentSubscription: null,
      organizationSubscriptionDetailsData: null,
      hasSubscription: false,
      cancelling: false,
      removing: false,
      subscriptionCallReturned: false,
      notifications: null,
      gettingNotifications: false,
      transferType: null,
      preferredDealer: null,
      isPreferredDealerLoaded: false,
      isCurrentSubscriptionLoaded: false
    }
  },
  computed: {
    ...mapState({
      currentAppConfig: state => state.application.currentAppConfig
    })
  },
  methods: {
    isActive(index) {
      if (index === this.tabIndex) {
        return 'active'
      }
      return ''
    },
    ImpersonateEmail() {
      // this.$store.dispatch('apparatusReset')
      this.$store.dispatch('clearNotificationApparatuses')
      this.$store.dispatch('setEmail', { email: this.value.ownerInformation.emails[0], userId: this.value?.userId })
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      if (newVal && this.hasDevice(newVal)) {
        this.$store
          .dispatch('getSearchResultStatus', {
            apparatusId: newVal.apparatusId,
            deviceType: newVal.deviceInfo.deviceType,
            deviceId: newVal.deviceInfo.deviceId
          })
          .catch(error => {
            if (error.response.data.status == 401) {
              this.$store.dispatch('displayToast', {
                title: this.$t('xError'),
                message: this.$t('xYourSessionHasExpiredPleaseReLogin'),
                variant: 'danger'
              })
              this.forceSignOut()
            }
          })
      }
    }
  },
  async mounted() {
    if (this.value && this.hasDevice(this.value)) {
      this.$store
        .dispatch('getSearchResultStatus', {
          apparatusId: this.value.apparatusId,
          deviceType: this.value.deviceInfo.deviceType,
          deviceId: this.value.deviceInfo.deviceId
        })
        .catch(error => {
          if (error.response.data.status == 401) {
            this.$store.dispatch('displayToast', {
              title: this.$t('xError'),
              message: this.$t('xYourSessionHasExpiredPleaseReLogin'),
              variant: 'danger'
            })
            this.forceSignOut()
          } else {
          }
        })
      if (!this.currentAppConfig) this.$store.dispatch('getApplicationConfiguration', 'Any')
    }
  }
}
</script>

<style scoped>
.btn {
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 400;
}
.card-title {
  font-size: 1.5rem;
  text-transform: uppercase;
  line-height: 1.25em;
  font-weight: 400;
}
.main-card {
  box-shadow: 0px -3px 20px rgba(0, 0, 0, 0.2);
  border-radius: 0.25rem;
  border: none;
}
.card-body {
  background-color: #ffffff;
}
.btn-danger.disabled,
.btn-danger:disabled {
  opacity: 0.65 !important;
}
</style>
